import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const ProductsSection = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleNavigate = () => {
    navigate('/products/categories');
  };

  if (isMobile) {
    return (
      <Box
        id="products"
        sx={{
          minHeight: '100vh',
          backgroundColor: '#d8d8bc',
          px: 2,
          py: 10,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '240px',
            borderRadius: '10px',
            backgroundColor: '#080808',
            backgroundImage: 'url(/img/30.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
          }}
        />

        <Typography
          sx={{
            fontFamily: 'Oswald',
            fontSize: '42px',
            fontWeight: 700,
            color: '#1A1A1A',
            lineHeight: 0.95,
          }}
        >
          OUR
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Oswald',
            fontSize: '42px',
            fontWeight: 700,
            color: '#2858A8',
            lineHeight: 0.95,
            mt: -0.8,
          }}
        >
          PRODUCTS
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 450,
            color: '#1A1A1A',
            lineHeight: 1.75,
          }}
        >
          We expertise in both Retail & Wholesale Products. Our bulk services have catered to countries like the USA, United Kingdom, Netherlands, Japan, & more!
        </Typography>

        <Button
          onClick={handleNavigate}
          sx={{
            alignSelf: 'flex-start',
            fontFamily: 'Oswald',
            fontSize: '15px',
            fontWeight: 600,
            color: '#FFFFFF',
            backgroundColor: '#2858A8',
            letterSpacing: '0.08em',
            px: 3,
            py: 1.2,
            borderRadius: '8px',
            border: '2px solid #2858A8',
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#2858A8',
              border: '2px solid #2858A8',
            },
          }}
        >
          View Our Products
        </Button>
      </Box>
    );
  }

  return (
    <Box
      id="products"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        backgroundColor: '#d8d8bc',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        style={{
          position: 'absolute',
          top: '20%',
          left: '5%',
          width: '45%',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Oswald',
            fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
            fontWeight: 700,
            color: '#1A1A1A',
            letterSpacing: '0.05em',
            lineHeight: 0.9,
            mb: 1,
          }}
        >
          OUR
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Oswald',
            fontSize: { xs: '48px', sm: '64px', md: '80px', lg: '96px' },
            fontWeight: 700,
            color: '#2858A8',
            letterSpacing: '0.05em',
            lineHeight: 0.9,
            mb: 4,
          }}
        >
          PRODUCTS
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Roboto',
            fontSize: { xs: '14px', md: '16px', lg: '18px' },
            fontWeight: 450,
            color: '#1A1A1A',
            lineHeight: 1.8,
            mb: 4,
          }}
        >
          We expertise in both Retail & Wholesale Products. Our bulk services have catered to countries like the USA, United Kingdom, Netherlands, Japan, & more!
        </Typography>

        <Button
          onClick={handleNavigate}
          sx={{
            fontFamily: 'Oswald',
            fontSize: { xs: '16px', md: '18px' },
            fontWeight: 600,
            color: '#FFFFFF',
            backgroundColor: '#2858A8',
            letterSpacing: '0.1em',
            px: 4,
            py: 1.5,
            borderRadius: '8px',
            border: '2px solid #2858A8',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: 'transparent',
              color: '#2858A8',
              border: '2px solid #2858A8',
            },
          }}
        >
          View Our Products
        </Button>
      </motion.div>

      {/* <Box
        sx={{
          position: 'absolute',
          right: '37%',
          top: '10%',
          height: '80%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 3,
        }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Box
            sx={{
              width: { xs: 150, md: 180, lg: 220 },
              height: { xs: 180, md: 220, lg: 260 },
              borderRadius: '12px',
              backgroundColor: '#F5F5F5',
              backgroundImage: 'url(/img/product1.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Box
            sx={{
              width: { xs: 150, md: 180, lg: 220 },
              height: { xs: 180, md: 220, lg: 260 },
              borderRadius: '12px',
              backgroundColor: '#F5F5F5',
              backgroundImage: 'url(/img/product2.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <Box
            sx={{
              width: { xs: 150, md: 180, lg: 220 },
              height: { xs: 180, md: 220, lg: 260 },
              borderRadius: '12px',
              backgroundColor: '#F5F5F5',
              backgroundImage: 'url(/img/product3.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            }}
          />
        </motion.div>
      </Box> */}

      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        style={{
          position: 'absolute',
          top: '0%',
          right: '-2%',
          width: '35%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundColor: '#080808',
            backgroundImage: 'url(/img/30.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'right center',
            backgroundRepeat: 'no-repeat',
            borderRadius: '0px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          }}
        />
      </motion.div>
    </Box>
  );
};

export default ProductsSection;
